import { memo, useEffect } from 'react';
import FormField from 'components/FormField';
import { InputNumber, Radio } from 'antd';
import { useTranslate } from '@tolgee/react';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';
import { FV, Validate } from './share';
import useSmartField from 'hooks/useSmartField';
import { PlatformProps, ScenarioTypeProps } from '../TaskForm/share';
import { shopeeReturnTradeScenarios } from '../config';

export const validate: Validate = (errors, values, t) => {
  const refundRatio = values.returnTradeConfig?.refundRatio;

  if (!refundRatio) {
    // eslint-disable-next-line no-param-reassign
    if (errors.returnTradeConfig) {
      errors.returnTradeConfig.refundRatio = t('请输入退款比例');
    } else {
      errors.returnTradeConfig = { refundRatio: t('请输入退款比例') };
    }
  }
};

const ChooseOps = memo(({ platform, scenarioType }: PlatformProps & ScenarioTypeProps) => {
  const { t } = useTranslate();
  const { whiteListConfig: { SHOPEE_ZDPF = false } = {} } = useOrgConfigStateValue();
  const { field } = useSmartField<Required<FV>['returnTradeConfig']['autoRefund']>(
    'returnTradeConfig.autoRefund',
  );
  const { field: returnTypeField } = useSmartField<Required<FV>['returnTradeConfig']['returnType']>(
    'returnTradeConfig.returnType',
  );
  const notSelectReturnRefund = !returnTypeField.value?.includes('RETURN_REFUND');
  useEffect(() => {
    notSelectReturnRefund && field.onChange(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notSelectReturnRefund]);

  return (
    <>
      {SHOPEE_ZDPF &&
        platform === 'SHOPEE' &&
        shopeeReturnTradeScenarios.includes(scenarioType) && (
          <FormField<Required<FV>['returnTradeConfig']['autoRefund']>
            name="returnTradeConfig.autoRefund"
            required
            label={t('选择操作')}
          >
            {({ field: { value, onChange } }) => {
              return (
                <Radio.Group
                  value={
                    notSelectReturnRefund
                      ? 'sendContent'
                      : value
                      ? 'setRefundAmount'
                      : 'sendContent'
                  }
                  onChange={(e) => {
                    onChange(e.target.value === 'setRefundAmount');
                  }}
                >
                  <Radio value="sendContent">{t('reviewSetting.发送内容')}</Radio>
                  <Radio value="setRefundAmount" disabled={notSelectReturnRefund}>
                    {t('发起部分退款')}
                  </Radio>
                </Radio.Group>
              );
            }}
          </FormField>
        )}
      {field.value && (
        <FormField<Required<FV>['returnTradeConfig']['refundRatio']>
          name="returnTradeConfig.refundRatio"
          label="&nbsp;"
          colon={false}
          className="!mt-[-24px] !mb-0"
        >
          {({ field: { value, onChange, onBlur } }) => (
            <div className="bg-[var(--fett-erp-card-bg)] flex items-center py-[8px] px-[16px]">
              {t('退款比例')}
              <InputNumber
                precision={0}
                value={value === 0 ? undefined : value}
                onChange={(value) => {
                  value && onChange(value);
                }}
                onBlur={onBlur}
                min={1}
                max={100}
                addonAfter="%"
                className="ml-[8px]"
              />
            </div>
          )}
        </FormField>
      )}
    </>
  );
});

export default ChooseOps;
